import { Benifit } from "@/models/ICommon"

import { PModal } from "../ConfirmModal/showModal"
import { getBenefitInfo } from "../ConfirmModal/showModal/content/roles"

const useBenefit = (props: { benefits?: Benifit }) => {
  const { benefits } = props

  if (!benefits) {
    return {
      hasBenefits: true,
      title: "",
      handleClick: () => {},
    }
  }

  const { kind, hasBenefits } = getBenefitInfo(benefits)

  const titleMap = {
    2: t("UpgradeToEssential"),
    3: t("UpgradeToProfessional"),
    4: t("UpgradeToEnterprise"),
  }

  const title = titleMap[kind]

  function handleClick(e?: any) {
    if (e) {
      e.stopPropagation()
      e.preventDefault()
    }
    PModal.showUpgradeModalByBenefits({ benefits: benefits as Benifit })
  }

  return {
    hasBenefits,
    title,
    handleClick,
  }
}

export default useBenefit
